import React from "react";
import "./loader.scss";

export default function Loader(props) {
    const { animationState } = props;
    
    return(
        <div class="lds-ellipsis animatable-400 ease-in-out-quart" style = {{opacity: animationState ? 1 : 0}} ><div></div><div></div><div></div><div></div></div>
    )
}